import { strToFloat, trimTextContent } from 'services/utils';

export default (newPaymentFormData) => ({
  amount: strToFloat(newPaymentFormData?.amount?.toString()),
  paymentMethod: newPaymentFormData?.paymentMethod,
  comment: trimTextContent(newPaymentFormData?.transferDetails)
});
